import { useState, useCallback, useRef } from "react";
import { QuestionnaireHandlerKey } from "../context/QuestionnaireContext";

export const useQuestionnaireDialog = () => {
  const [dialogAction, setDialogAction] =
    useState<QuestionnaireHandlerKey | null>(null);
  const [dialogWarningDescription, setDialogWarningDescription] = useState<
    string | null
  >(null);
  const dialogConfirmCallback = useRef<(() => void) | null>(null);

  const openDialog = useCallback(
    (
      action: QuestionnaireHandlerKey,
      onConfirm: () => void,
      warningDescription?: string | null,
    ) => {
      setDialogAction(action);
      setDialogWarningDescription(warningDescription || null);
      dialogConfirmCallback.current = onConfirm;
    },
    [],
  );

  const closeDialog = useCallback(() => {
    setDialogAction(null);
    setDialogWarningDescription(null);
    dialogConfirmCallback.current = null;
  }, []);

  const confirmDialog = useCallback(() => {
    if (dialogConfirmCallback.current) {
      dialogConfirmCallback.current();
    }
  }, []);

  return {
    dialogAction,
    dialogWarningDescription,
    openDialog,
    closeDialog,
    confirmDialog,
  };
};
